"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSidebarPopover = void 0;
var style_utils_1 = require("@nef/style-utils");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Popover_1 = __importDefault(require("../../../Popover"));
var Sidebar_1 = require("../../../Sidebar");
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var active = _a.active, bottom = _a.bottom, props = __rest(_a, ["active", "bottom"]);
    return react_1.default.createElement(Popover_1.default, __assign({}, props, { ref: ref }));
});
innerFunction.displayName = "innerFunction";
exports.StyledSidebarPopover = styled_components_1.default(innerFunction)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), style_utils_1.getSidebarColor(0));
var SidebarPopover = (function (_super) {
    __extends(SidebarPopover, _super);
    function SidebarPopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SidebarPopover.prototype.render = function () {
        var rtl = this.context.rtl;
        var _a = this.props, children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
        return (react_1.default.createElement(exports.StyledSidebarPopover, __assign({}, props, { className: style_utils_1.classNames("sidebar--popover", className), fixed: true, maxContent: true, offsetRight: rtl ? 0 : -3, offsetLeft: rtl ? 3 : 0, placement: rtl ? "left-start" : "right-start", rtl: rtl, isAnimated: false }), children));
    };
    SidebarPopover.contextType = Sidebar_1.SidebarContext;
    return SidebarPopover;
}(react_1.default.PureComponent));
exports.default = SidebarPopover;
var templateObject_1;
//# sourceMappingURL=index.js.map